.ch{aspect-ratio:1/1;}